export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function getScreenCenterCoords(): [number, number] {
  if (!window) return [200, 200];
  let x = window.innerWidth / 2;
  let y = window.innerHeight / 2;
  return [x, y];
}export function calcShiftedAfterLine(prevShifted: boolean, line: string) {
  let shifted = prevShifted;
  for (let i = 0; i < line.length; i++) {
    if (line[i] == "\x0E") {
      shifted = true;
    } else if (line[i] == "\x0F") {
      shifted = false;
    }
  }
  return shifted;
}
export function processStory(script: string) {
  script = script.replaceAll(/\\b/g, "\b");
  let scriptLines = script.split("\n").map(line => line.trimEnd());
  let lines = [];
  let markers = new Map<string, number>();
  for (let i = 0; i < scriptLines.length; i++) {
    let line = scriptLines[i];
    let meta = line.slice(72).trim();
    if (meta.startsWith("#")) {
      markers.set(meta, i);
    } else if (meta == "") {
      // ...
    } else {
      throw new Error(`Invalid story format on line ${i + 1}: ${line}`);
    }
  }

  for (let i = 0; i < scriptLines.length; i++) {
    let line = scriptLines[i];
    let text = line.slice(0, 72).trimEnd();
    text = text.replaceAll(/#[A-Z][A-Z][A-Z]/ig, match => {
      let marker = markers.get(match);
      if (marker === undefined) {
        return `?${match.slice(1)}`;
      }
      return (marker + 1).toString();
    });
    lines.push(text);
  }
  return lines.join("\n") + "\n";
}

type UploadedFile = { name: string, content: string };

export function readUploadedFile(file: File): Promise<UploadedFile> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event.target && event.target.result) {
        resolve({
          name: file.name,
          content: event.target.result as string
        });
      } else {
        reject(new Error("Failed to read file"));
      }
    };
    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };
    reader.readAsText(file);
  });
}

export function isProbablyText(text: string): boolean {
  // Check for a high ratio of readable characters
  const totalLength = text.length;
  let readableChars = 0;

  for (let i = 0; i < totalLength; i++) {
    const code = text.charCodeAt(i);
    if (
      (code >= 32 && code <= 126) || // Basic printable ASCII
      code === 10 || code === 13 ||  // Line breaks
      code === 9                    // Tabs
    ) {
      readableChars++;
    }
  }

  const ratio = readableChars / totalLength;
  return ratio > 0.95; // 95% readable = probably text
};

export function wrap(string: string, length: number = 72) {
  return string.split("\n");
}
export function loadOrDefault<T>(key: string, defaultValue: T): T {
  const value = localStorage.getItem(key);
  if (value) {
    try {
      return JSON.parse(value) as T;
    } catch (e) {
      console.error(`Error parsing ${key} from localStorage:`, e);
    }
  }
  return defaultValue;
}

export const COL_WIDTH = 72;

export function calcVisualPos(pos: number, char: string) {
  if (char == "\b") {
    return Math.max(1, pos - 1);
  } else if (char == "\x0E" || char == "\x0F" || char == "\x07") {
    return pos;
  } else if (pos == COL_WIDTH) {
    return pos;
  }
  return pos + 1;
}

console.assert(calcVisualPos(1, "a") == 2);
console.assert(calcVisualPos(1, "a") == 2);
console.assert(calcVisualPos(1, "\b") == 1);
console.assert(calcVisualPos(2, "\b") == 1);
console.assert(calcVisualPos(2, "a") == 3);
console.assert(calcVisualPos(2, "\x0E") == 2);
console.assert(calcVisualPos(2, "\x0F") == 2);
console.assert(calcVisualPos(2, "\x07") == 2);
console.assert(calcVisualPos(COL_WIDTH - 1, "a") == COL_WIDTH);
console.assert(calcVisualPos(COL_WIDTH, "a") == COL_WIDTH);
console.assert(calcVisualPos(COL_WIDTH, "\x0E") == COL_WIDTH);
console.assert(calcVisualPos(COL_WIDTH, "\x0F") == COL_WIDTH);
console.assert(calcVisualPos(COL_WIDTH, "\b") == COL_WIDTH - 1);


export function visualLength(text: string) {
  let chars = text.replaceAll("\t", "    ").split("");
  let visualPos = 1;
  for (let i = 0; i < chars.length; i++) {
    let char = chars[i];
    visualPos = calcVisualPos(visualPos, char);
  }
  return visualPos;
}
